module.exports = __webpack_public_path__ + "img/edit-blue.f705d141.svg";